module.exports = __webpack_public_path__ + "static/logo-02-c945da10b0dddc95e6142bdf119fa814.svg";